import ForgotPassword from "../../components/ForgotPassword/forgot-password"

export default function ForgotPasswordPage(){
    return <ForgotPassword />;
}